// extracted by mini-css-extract-plugin
export default {"gridContainer":"gridProductsAdmin_gridContainer__gOMWn","product":"gridProductsAdmin_product__R6zf8","image":"gridProductsAdmin_image__hZirq"};